// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"e996f817","231":"5df7dc4a","309":"2cdace24","331":"3fc2b37b","332":"6e95f8bb","404":"6b587215","424":"341a2851","485":"949ff0f8","858":"e6d7f581","873":"f16d0920","900":"85d03ef2","999":"afa23ade"}[chunkId] + ".chunk.js";
};